export const formatInvestment = investment => {
    if (!investment && typeof investment !== "string") {
        return undefined;
    }

    return investment.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ") + ' €';
};

export const roundInvestment = delimiter => investment => {
    if (!investment && investment !== 0) {
        return 0;
    }
    
    const value = Number(investment);

    if (isNaN(value)) {
        return 0;
    }

    return Math.round(investment / delimiter) * delimiter;
}